module.exports = __webpack_public_path__ + "img/icon-exclamation-white.f5183a0d.svg";